/**
 * Synthetic cursor for visual demo feedback.
 * Animates smoothly to target elements and shows click ripple.
 */

const CURSOR_ID = 'da-cursor';

const CURSOR_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
  <path d="M5.65376 12.3673H5.46026L5.31717 12.4976L0.500002 16.8829L0.500002 1.19841L11.7841 12.3673H5.65376Z" fill="white" stroke="black"/>
</svg>`;

let cursorEl: HTMLElement | null = null;
let curX = 0;
let curY = 0;

function ensureCursor(): HTMLElement {
  if (cursorEl && document.getElementById(CURSOR_ID)) return cursorEl;

  cursorEl = document.createElement('div');
  cursorEl.id = CURSOR_ID;
  cursorEl.innerHTML = CURSOR_SVG;
  Object.assign(cursorEl.style, {
    position: 'fixed', top: '0', left: '0',
    width: '20px', height: '20px',
    zIndex: '2147483647', pointerEvents: 'none',
    transition: 'none',
    transform: `translate(${curX}px, ${curY}px)`,
    opacity: '0',
    filter: 'drop-shadow(1px 2px 2px rgba(0,0,0,0.3))',
  });
  document.body.appendChild(cursorEl);
  return cursorEl;
}

export async function animateCursorTo(selector: string, durationMs = 400): Promise<void> {
  const target = document.querySelector(selector);
  if (!target) throw new Error(`Cursor target not found: ${selector}`);

  const rect = target.getBoundingClientRect();
  curX = rect.left + rect.width / 2;
  curY = rect.top + rect.height / 2;

  const cursor = ensureCursor();
  cursor.style.opacity = '1';
  cursor.style.transition = `transform ${durationMs}ms cubic-bezier(0.4, 0, 0.2, 1)`;
  cursor.style.transform = `translate(${curX}px, ${curY}px)`;

  await new Promise((r) => setTimeout(r, durationMs));
}

export async function showClickRipple(): Promise<void> {
  const ripple = document.createElement('div');
  Object.assign(ripple.style, {
    position: 'fixed', left: `${curX - 15}px`, top: `${curY - 15}px`,
    width: '30px', height: '30px', borderRadius: '50%',
    border: '2px solid rgba(124, 58, 237, 0.6)',
    pointerEvents: 'none', zIndex: '2147483646',
    animation: 'da-ripple 0.4s ease-out forwards',
  });

  if (!document.getElementById('da-ripple-style')) {
    const style = document.createElement('style');
    style.id = 'da-ripple-style';
    style.textContent = `@keyframes da-ripple { 0% { transform: scale(0.5); opacity: 1; } 100% { transform: scale(2); opacity: 0; } }`;
    document.head.appendChild(style);
  }

  document.body.appendChild(ripple);
  await new Promise((r) => setTimeout(r, 400));
  ripple.remove();
}

export function hideCursor(): void {
  if (cursorEl) cursorEl.style.opacity = '0';
}
